export default __webpack_public_path__ + "static/char-s-45-ja-e1d2f0fab4e72cc11e22e40714f8d86e.png";